module.exports = __webpack_public_path__ + "static/media/pic_01.37a9276f.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/pic_01.png
// module id = 592
// module chunks = 0